import { Component, inject, OnInit, effect } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import * as _ from 'underscore';
import { IBackgroundDetails } from 'src/app/models/signup-questions.model';
import { SignupQuestionsSignal } from 'src/app/signal/signup-questions.signal';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NgClass } from '@angular/common';

@Component({
	selector: 'app-third-step',
	templateUrl: './third-step.component.html',
	styleUrl: './third-step.component.scss',
	imports: [FormsModule, ReactiveFormsModule, NzInputModule, NgClass]
})
export class ThirdStepComponent implements OnInit {
	private readonly signupQuestionsSignal = inject(SignupQuestionsSignal);

	public form: FormGroup;
	private isFormUpdating = false;

	constructor() {
		// Effect to watch background details from signal for form patching
		effect(() => {
			const backgroundDetails = this.signupQuestionsSignal.backgroundDetails();

			if (this.isFormUpdating && !_.isEmpty(backgroundDetails)) {
				this.isFormUpdating = false;
				this.form?.patchValue({
					linkedInUrl: backgroundDetails.linkedInUrl,
					whyJoinToCompany: backgroundDetails.whyJoinToCompany
				});
			}
		});
	}

	public ngOnInit(): void {
		this.isFormUpdating = true;
		this.buildForm();
		this.patchFormFromSignal();
		this.checkFormValue();
	}

	private patchFormFromSignal(): void {
		const backgroundDetails = this.signupQuestionsSignal.backgroundDetails();

		if (!_.isEmpty(backgroundDetails)) {
			this.isFormUpdating = false;
			this.form.patchValue({
				linkedInUrl: backgroundDetails.linkedInUrl,
				whyJoinToCompany: backgroundDetails.whyJoinToCompany
			});
		}
	}

	private checkFormValue(): void {
		this.form.valueChanges.subscribe((value: IBackgroundDetails) => {
			this.patchStoreData(value);
		});
	}

	private patchStoreData(value: IBackgroundDetails): void {
		this.signupQuestionsSignal.patchBackgroundDetails({
			...value,
			linkedInUrl: this.normalizeLinkedInUrl(value.linkedInUrl),
			isFormValid: this.form.valid
		});
	}

	private normalizeLinkedInUrl(url: string | null): string | null {
		if (!url) return url;

		// Remove protocol and www if present
		let normalized = url.trim()
			.replace(/^https?:\/\//, '')
			.replace(/^www\./, '');

		// Add https://www. prefix
		return `https://www.${normalized}`;
	}

	private buildForm(): void {
		const linkedInPattern = /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/;
		this.form = new FormGroup({
			linkedInUrl: new FormControl(null, [Validators.pattern(linkedInPattern)]),
			whyJoinToCompany: new FormControl(null)
		});
	}
}
